





module.exports =
	components:
		identity: require "./identity"
		primaryNav: require "./primaryNav"
	computed:
		isTop: -> this.$route.name.replace("en_","") is "top"



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/common/siteHeader.vue